import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { useDispatch } from 'react-redux'

import useAnalytics from '@/hooks/useAnalytics'
import { resetNotFound } from '../../actions/common'
import { goToMyAccount } from 'utils/navigate'
import IconPage from 'components/common/IconPage'
import { getLayoutElementDetails } from 'utils/screens/common'

const notFoundImpressionTags = {
  page: `pageNotFound`,
  eventName: 'ucs_page_not_found_screen_shown',
}

const doneBtnClickTags = {
  link: 'doneBtn',
  eventName: 'ucs_page_not_found_done_pressed',
}

function NotFound({ wrapWithLayout = true }) {
  const { recordClientClick } = useAnalytics(notFoundImpressionTags)
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch(resetNotFound())
    }
  }, [dispatch])

  const handleDoneButton = () => {
    recordClientClick(doneBtnClickTags)
    goToMyAccount({ dispatch })
  }

  let LayoutElement = React.Fragment
  let layoutElementProps = {}

  if (wrapWithLayout) {
    const { LayoutElement: Element, layoutElementProps: elementProps } = getLayoutElementDetails()
    LayoutElement = Element
    layoutElementProps = elementProps
  }

  return (
    <LayoutElement {...layoutElementProps}>
      <IconPage
        data-testid="not-found-page"
        headerId="notFound.header"
        headerTestId="not-found-header"
        contentId="notFound.content"
        wrapWithModalContent
      >
        <Button data-testid="not-found-done-button" onClick={handleDoneButton}>
          <Message id="common.button.done" />
        </Button>
      </IconPage>
    </LayoutElement>
  )
}

NotFound.propTypes = {
  wrapWithLayout: PropTypes.bool,
}

export default NotFound
